/**
 * @property value type object : {year: integer, month: integer, day: integer}
 * Los días habilitados dependerán de una fecha mínima y máxima.
 * Los días pueden estar en uno o varios meses, lo que permite habilitar el cambio de mes a aquellos que tengan estos días habilitados.
 * @property minimumDate type object : {year: integer, month: integer, day: integer}
 * @property maximumDate type object : {year: integer, month: integer, day: integer}
 * Del rango de días habilitados, podemos enviar un array de objetos {year: integer, month: integer, day: integer} para deshabilitar algunos días.
 * @property disabledDays type array : [{year: integer, month: integer, day: integer}, {year: integer, month: integer, day: integer}, ...]
 * @property calendarVerticalPosition (optional) Si no se define, el calendario se adapta a `top` o `bottom` dependiendo del espacio.
 * @property calendarClassName type string :
 * @property inputPlaceholder type string :
 * @property onChange type function : (e) => onChange(e) donde "e" es la fecha seleccionada: {year: integer, month: integer, day: integer}.
 * @property disabled type boolean : Si es `true`, deshabilita el calendario.
 */

/* eslint-disable react/prop-types */
import React from 'react';
import DatePicker from 'react-modern-calendar-datepicker';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import myCustomLocale from './myCustomLocale';

import './styles.css';

const DatePickerExternal = (props) => {
  const {
    value,
    onChange,
    inputPlaceholder,
    inputClaseName,
    calendarClassName,
    calendarVerticalPosition,
    disabledDays,
    minimumDate,
    maximumDate,
    disabled, // Nuevo prop
  } = props;

  // Renderizado de un input personalizado cuando está deshabilitado
  const renderCustomInput = ({ ref }) => (
    <input
      readOnly
      ref={ref} // Necesario para el componente
      placeholder={inputPlaceholder}
      value={value ? `${('0' + value.day).slice(-2)}/${('0' + value.month).slice(-2)}/${value.year}` : ''}
      className={inputClaseName}
    />
  );

  // Si el componente está deshabilitado, renderiza un input estático
  if (disabled) {
    return (
      <input
        readOnly
        placeholder={inputPlaceholder}
        value={value ? `${('0' + value.day).slice(-2)}/${('0' + value.month).slice(-2)}/${value.year}` : ''}
        className={`${inputClaseName} disabled`}
        style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }} // Estilo para deshabilitar el input
      />
    );
  }

  // Renderizado normal del DatePicker cuando no está deshabilitado
  return (
    <section
      className={`Wrapper-Datapicker Wrapper-Datapicker--${calendarVerticalPosition || 'bottom'}`}
    >
      <DatePicker
        value={value}
        renderInput={renderCustomInput}
        calendarClassName={calendarClassName}
        disabledDays={disabledDays}
        locale={myCustomLocale}
        minimumDate={minimumDate}
        maximumDate={maximumDate}
        onChange={onChange}
      />
    </section>
  );
};

export default DatePickerExternal;
